import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
    return (
        <footer className="app-footer">
            <p>© 2025 devpanpan. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
